import React, { useContext, useState, useEffect } from 'react';
import { Dropdown, Menu, Avatar } from 'antd';
import { UserOutlined, SettingOutlined, LogoutOutlined, LoginOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import sso from 'freesia-sso';
import Sso from '@yulintu/freesia-react-component-sso';

import { Application } from "@yulintu/freesia-bootstrap";

import "./index.less";

const Addon = function (props) {

    const context = useContext(Application.Context);

    const ssoContext = useContext(Sso.Context);
    const { userInfo } = context.global || {};
    const nickname = (userInfo?.realname || userInfo?.nickname || userInfo?.name || "").trim();
    const username = (userInfo?.name || "").trim();
    const userid = (userInfo?.id || "").trim();

    const [userPortraitError, setUserPortraitError] = useState(false);
    const [userPortrait, setUserPortrait] = useState();

    const [menuClickItem, setMenuClickItem] = useState();

    useEffect(() => {
        setUserPortrait(!userid ? undefined : `${context.config.ssoSiteUrl}/account/member/${userid}/portrait`);
    }, [userid, context.config.ssoSiteUrl]);

    const items = [{
        key: "用户中心",
        icon: <SettingOutlined />,
        label: "用户中心",
        onClick: () => {
            let ssoSiteUrl = context?.config?.ssoSiteUrl;
            if (ssoSiteUrl) {
                window.open(ssoSiteUrl + '/center', "_blank");
            }
        }
    }, {
        key: "客服中心",
        icon: <CustomerServiceOutlined />,
        label: "客服中心",
        onClick: () => {
            let ssoSiteUrl = context?.config?.ssoSiteUrl;
            if (ssoSiteUrl) {
                window.open(ssoSiteUrl + '/center/workorder', "_blank");
            }
        }
    }];
    if ((props.metadata?.props?.extra || []).length) {
        items.push({
            type: 'divider'
        });

        items.push(...(props.metadata?.props?.extra || []).map((c, i) => {

            if (!c.template)
                return null;

            let component = null;
            if (typeof c.template === "string")
                component = context.factory.loadPure(c.template, { ...c.props, metadata: c, key: c.key || (i + "") }, { key: c.key || (i + "") });

            if (c.divider)
                return {
                    type: 'divider'
                }
            else {
                const originItem = component.menuItem?.();
                if (originItem) {
                    if (menuClickItem?.key === originItem.key) {
                        return component.menuItem?.({ clickStamp: menuClickItem?.stamp });
                    }
                }
                return originItem || null;
            }
        }));
    }
    items.push(...[{
        type: 'divider'
    }, userid ? {
        key: "退出",
        label: "退出",
        icon: <LogoutOutlined />,
        onClick: () => {
            sso.logout({
                searchParams: ssoContext?.searchParams || undefined
            });
        }
    } : {
        key: "去登录",
        label: "去登录",
        icon: <LoginOutlined />,
        onClick: () => {
            Sso.execute(null, e => {
                context.webSocket?.send("identify", e.data?.name);
                context.setGlobal({ userInfo: e.data })
            })
        }
    }]);

    return (
        <Dropdown className="primary-header-dropdown user-menu" menu={{
            items: [...items.map(item => {
                return {
                    ...item,
                    onClick: undefined
                }
            })],
            onClick: ({ key, keyPath, domEvent }) => {
                const item = items.find(d => d.key === key);
                if (item.onClick) {
                    item.onClick();
                } else {
                    setMenuClickItem({
                        key,
                        stamp: Math.random()
                    })
                }
            }
        }} placement="bottomLeft" overlayClassName="primary-header-dropdown-popup-menu">
            <a className="ant-dropdown-link layout-h center" onClick={e => {
                if (!userid)
                    Sso.execute(null, e => {
                        context.webSocket?.send("identify", e.data?.name);
                        context.setGlobal({ userInfo: e.data })
                    })
            }}>
                <div className='user-avatar'>
                    {
                        !userPortrait || userPortraitError ? (
                            <Avatar className={nickname && "login"} size={"large"} icon={nickname ? undefined : <UserOutlined />}>
                                {username ? username.substring(0, 1).toUpperCase() : ""}
                            </Avatar>
                        ) : null
                    }
                    {
                        !userPortraitError && userid ? (
                            <img
                                className='user-portrait'
                                src={userPortrait}
                                onError={e => { setUserPortraitError(true); setUserPortrait(null) }}
                            />
                        ) : null
                    }
                </div>

                <div className="name">{nickname || "未登录"}</div>
            </a>
        </Dropdown>
    );
}

export default Addon;